export default __webpack_public_path__ + "static/media/analytics-img_mobile.383ca8f3.png";